'use client';

import Link from 'next/link';
import { toast } from '@/hotdesk-ui/components/toast-v4';
type FavoriteToastLabels = {
  message: string;
  viewAll: string;
};

/**
 * Success toast for favourite add/remove, with a "View all" link to /favorites.
 */
export function showFavoriteToast({
  message,
  viewAll
}: FavoriteToastLabels) {
  toast.success(<div className="favorite-toast">
            <span className="favorite-toast__message">{message}</span>
            <Link href="/favorites" className="favorite-toast__view-all" onClick={e => {
      e.stopPropagation();
      toast.dismiss();
    }}>
                {viewAll}
            </Link>
        </div>, {
    position: 'bottom-center'
  });
}